import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import SpinnerOverlay from '../App/components/SpinnerOverlay';

const LoadingContext = createContext<
  [boolean, React.Dispatch<React.SetStateAction<boolean>>]
>([false, () => {}]);
const LoadingStateContext = createContext(false);
const LoadingSetterContext = createContext<
  React.Dispatch<React.SetStateAction<boolean>>
>(() => {});

const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(false);

  const memoContextValue = useMemo(() => {
    return [loading, setLoading] as [
      boolean,
      React.Dispatch<React.SetStateAction<boolean>>
    ];
  }, [loading]);
  const memoSetLoading = useCallback(setLoading, []);
  return (
    <LoadingContext.Provider value={memoContextValue}>
      <LoadingStateContext.Provider value={loading}>
        <LoadingSetterContext.Provider value={memoSetLoading}>
          <SpinnerOverlay show={loading} />
          {children}
        </LoadingSetterContext.Provider>
      </LoadingStateContext.Provider>
    </LoadingContext.Provider>
  );
};

export const useIsLoading = () => {
  return useContext(LoadingStateContext);
};

export const useLoading = () => {
  return useContext(LoadingContext);
};

export const useLoadingSetter = () => {
  return useContext(LoadingSetterContext);
};

export default LoadingProvider;
